import type { TemplateRef } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

export const AppFunc = {
  headerContent$: new ReplaySubject<TemplateRef<unknown> | null>(1),
  rightSidebarContent$: new ReplaySubject<TemplateRef<unknown> | null>(1),
  toggleRightSidebar$: new BehaviorSubject(false),
};
